var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.888,
    height: 28.888,
    viewBox: "0 0 28.888 28.888",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28.888,
    height: 28.888,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.079 5.506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.951,505.2H338.49a6.013,6.013,0,0,1-6.006-6.006v-6.575a6.012,6.012,0,0,1,6.006-6.005h7.461a6.012,6.012,0,0,1,6.005,6.005V499.2A6.013,6.013,0,0,1,345.951,505.2Zm-7.461-17.251a4.676,4.676,0,0,0-4.671,4.671V499.2a4.676,4.676,0,0,0,4.671,4.671h7.461a4.676,4.676,0,0,0,4.671-4.671v-6.575a4.676,4.676,0,0,0-4.671-4.671Z",
    transform: "translate(-332.484 -486.618)",
    fill: "#5f00e6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.391 3.947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.426,520.322a5.346,5.346,0,1,1,5.346-5.346A5.352,5.352,0,0,1,363.426,520.322Zm0-9.357a4.011,4.011,0,1,0,4.011,4.011A4.016,4.016,0,0,0,363.426,510.964Z",
    transform: "translate(-358.08 -509.63)",
    fill: "#5f00e6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.891 3.002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.682,505.23a1.109,1.109,0,1,1-1.109-1.11A1.109,1.109,0,0,1,415.682,505.23Z",
    transform: "translate(-413.464 -504.12)",
    fill: "#5f00e6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.6f15e17827ef05a8904eeb7b966ca350.svg";
export { ForwardRef as ReactComponent };